import React from 'react'
import styled from 'styled-components'
import DesktopView from "./Statistic.desktop";
import StatisticMobile from "./Statistic.mobile";
import {NamesListTypes} from "../../../components/analytic/NamesList/NamesList";
import {ChartTypes} from "../../../components/analytic/Chart/Chart";


type AnalyticPlacesProps = {
    className?: string
    loading: boolean,
    chartTypes: ChartTypes,
    readingStart: { checked: any, onChange: any, hide: boolean},
    blocks?: {
        allReading?: string | number,
        allErrors?: string | number,
        allEarned?: string | number,
        minimalCount?: any,
        maximumCount?: any,
        averageCount?: any,
        balance?: any
    }
    list?: NamesListTypes,
    breadCrumbs?: Array<any>

}

function AnalyticPlacesLayout(props: AnalyticPlacesProps ) {

    return (
        <StyledStatistics className={props.className}>
            <DesktopView className={'desktopView'} {...props} />
            <StatisticMobile className={'mobileView'} {...props} />
        </StyledStatistics>
    )
}


const StyledStatistics = styled.div`
  z-index: 10;
  padding: 20px;

  .desktopView {
    display: flex;
  }

  .tabletView {
    display: none;
  }

  .mobileView {
    display: none;
  }


  @media (max-width: 1100px) {
    .desktopView {
      display: none;
    }

    .mobileView {
      display: flex;
      padding-bottom: 100px;
      margin-top: 60px;

    }
  }
`

export default AnalyticPlacesLayout